import {
    APP_CONTENT_SIZE_SET, APP_IS_IE_SET, APP_SHOW_IMPERSONATE_MODAL, APP_FETCH_ABOUT_CURRENT_USER,APP_FETCH_ABOUT_CURRENT_USER_ERROR,APP_FETCH_ABOUT_CURRENT_USER_SUCCESS,APP_IMPERSONATE_USER,
    APP_IMPERSONATE_USER_ERROR,APP_IMPERSONATE_USER_SUCCESS,APP_SNACKBAR_MESSAGE_SET,APP_WAKEUP,APP_WAKEUP_SUCCESS,APP_WAKEUP_ERROR,APP_IS_LOGGED_IN_UPDATE,
    RESET_ALL_REDUX_STATE
} from './Types';

import WebServices from '../WebServices';


const setContentSize = contentSize => ({ type: APP_CONTENT_SIZE_SET, payload: contentSize });


const setIsIE = isIE => ({ type: APP_IS_IE_SET, payload: isIE });

const showImpersonateModal = showModal => ({ type: APP_SHOW_IMPERSONATE_MODAL, payload: showModal });

const updateLoggedInStatus = () => {

    const authID = document.cookie.match(new RegExp('(^| )AuthID=([^;]+)'));

    return { type: APP_IS_LOGGED_IN_UPDATE, payload: !!authID }
}


const showSnackBarMessage = (message,errorMessage,timeout = 2000) => dispatch => {
    dispatch({ type: APP_SNACKBAR_MESSAGE_SET, payload: errorMessage ? errorMessage : message });
    setTimeout(function () { dispatch({ type: APP_SNACKBAR_MESSAGE_SET, payload: null }) }, timeout);
}

const impersonateUser = (bun) => (dispatch, getState) => {

    dispatch(updateLoggedInStatus());

    dispatch({ type: APP_IMPERSONATE_USER });
    let webServices = new WebServices();
    webServices.impersonate(bun)
        .then((userInfo) => {
            dispatch({ type: APP_IMPERSONATE_USER_SUCCESS, payload: userInfo });
            dispatch(showImpersonateModal(false));
            dispatch(showSnackBarMessage('Impersonate Success. Page Will Reload'));
            setTimeout(() => window.location.reload(), 3000);
        })
        .catch((error) => {
            dispatch({ type: APP_IMPERSONATE_USER_ERROR, payload: error });
            dispatch(showSnackBarMessage('Error Impersonating User'));
        });
}

const fetchWakeup = () => (dispatch, getState) => {

    dispatch({ type: APP_WAKEUP });

    let webServices = new WebServices();

    webServices.getWakeup()
        .then((wakeUpInfo) => {
            if (wakeUpInfo.isAuthenticated === false && wakeUpInfo.isInternal === true) {
                // var host = window.location.hostname;
                // if (host === 'localhost') {
                //     // window.location.href = '/api/sso/login/localhost';
                // } else {
                //     window.location.href = '/api/b2c/signin';
                // }
                window.location.href = '/api/b2c/signin';
            }

            dispatch({ type: APP_WAKEUP_SUCCESS, payload: wakeUpInfo });
        })
        .catch((error) => {
            dispatch({ type: APP_WAKEUP_ERROR, payload: error });
        });
}

const fetchAboutCurrentUser = () => async (dispatch, getState) => {

    dispatch({ type: APP_FETCH_ABOUT_CURRENT_USER });

    dispatch(updateLoggedInStatus());

    if (getState().app.isLoggedIn === false) return;


    let webServices = new WebServices();

    try {
        const userInfo = await webServices.getAboutCurrentUser()
        const userDetails = await webServices.getUserDetails(userInfo.id);

        userInfo.permissions = userDetails.permissions;
        userInfo.approvalRoles = userDetails.approvalRoles;

        dispatch({ type: APP_FETCH_ABOUT_CURRENT_USER_SUCCESS, payload: userInfo });

    }catch (error) {
        dispatch({ type: APP_FETCH_ABOUT_CURRENT_USER_ERROR, payload: error });

    }

}

const resetAllReduxState = () => ({ type: 'RESET_ALL_REDUX_STATE' });

export { impersonateUser, setContentSize, setIsIE, showSnackBarMessage,updateLoggedInStatus, fetchAboutCurrentUser, showImpersonateModal, fetchWakeup, resetAllReduxState };
